import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbCalendar, NgbDate, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import "rxjs/add/operator/merge";
import { Utils } from "src/app/common/utils";
import { AllPatient } from "src/app/models/patient";
import { Checkin } from "src/app/models/scheckin";
import { Appointment } from "../../models/appointment";
import { PatientD } from "../../models/Pdetails";
import { VproService } from "./../../service/vpro/vpro.service";
import { Location } from '@angular/common';
import { sortBy } from "underscore";
import Swal from 'sweetalert2';


import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
//import { FieldControlService } from "src/app/forms/models/field-control.service";
import { Extend } from "./../../models/extend";
declare var $: any;


import { environment } from "src/environments/environment";
import moment from "moment";
import { TrimFormValuesService } from "src/app/common/trimmingForm";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.css"],
})
export class CheckoutComponent implements OnInit {

  @ViewChild('showprescriptionModal', { static: true } as any) showprescriptionModal: TemplateRef<any>;
  @ViewChild('showlabrepModal', { static: true } as any) showlabrepModal: TemplateRef<any>;
  @ViewChild('showservicerepModal', { static: true } as any) showservicerepModal: TemplateRef<any>;
  @ViewChild('editRequestModal', { static: true } as any) editRequestModal: TemplateRef<any>;
  disableSubmit: boolean = false;
  count: number = 0;
  buttonDisabled: boolean = false;
  PrescriptionType = Utils.PRESCRIPTIONTYPE;
  currentPrescriptionList: any[] = [];
  currentSerList: any[] = [];
  momentDate: any;
  patientd = new PatientD();
  checkin = new Checkin();
  pappoint = [];
  pat: string;
  patient = [];
  allpat = new AllPatient();
  submitted: boolean;
  message: string;
  public model: any;
  public model2: any;
  checkout: any[] = [];
  physicians = [];
  apdata = [];
  chkpat: any;
  dataOfPatient: any;
  innerHtml: string;
  appointment = new Appointment();
  dataValue: boolean;
  searchphy: any;
  isCheckOutLoading: boolean;
  phy: string;
  appoint: {};
  router: any;
  data: any;
  activeindex = -1;
  title: string;
  name: any;
  aid: any;
  apid: any;
  appointName = [];
  cid: any;
  birth: any;
  checkoutStatus: boolean;
  isError: boolean;
  org_code: any;
  chkdob: any;
  defaultDr = Utils.DEFAULTDR;
  httpClient: any;
  selectedFile: File;
  allpatients = new AllPatient();
  physician = [];
  bills = []
  extend = new Extend();
  orgdet: any;
  currentTab: string = "appetiteHabits";
  tot: number = 0;
  pdf_url = null;
  dateFormat = Utils.DATE_FORMAT;
  listOfTabs: any[] = [
    {
      id: "medicalHistory",
      title: "Medical History",
    },
  ];
  dcred: any;
  forms = {
    medicalHistory: null,
  };
  patient_med_history: FormArray;
  ppfile: File = null;
  ppurl: String = "";
  pp_content_type: String = "";
  diseaseList: any = [];
  service_names: any;
  searchValue: number;
  sum: number;
  z: number = 0;
  y: number;
  testsList: any[];
  serviceList: any[];
  totalamount: any;
  allowedReportTypes = ".xls, .xlsx, .pdf, .png, .jpg";
  aaid: any;
  drid: any;
  pid: any;
  ppid: any;
  ppids: any;
  maxDate: { year: number; month: number; day: number };
  aptid: any;
  patid: any;
  val: any = { chkdob: '', model: '', model2: '' };
  service_cost: any = [];
  service: any;
  dr_id: any;
  //serviceLists: import("/home/roshan/github code/SoopDoc/src/app/models/orgsrv").OrgService;
  constructor(
    private modal: NgbModal,
    private route: ActivatedRoute,
    private vproService: VproService,
    private addPService: VproService,
    private patService: VproService,
    private calendar: NgbCalendar,
    private utils: Utils,
    private location: Location,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private trimFormValuesService: TrimFormValuesService

  ) {

    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    this.forms.medicalHistory = this.fb.group({
      patient_med_history: this.fb.array([]),
    });
    this.momentDate = moment().format("YYYY-MM-DD");
  }

  ngOnInit() {
    this.org_code = localStorage.getItem("orgcode");
    this.apid = this.route.snapshot.params['aid'];
    this.getOrgDet(localStorage.getItem("LogUsr"));
    this.getDiseaseList(); // get services - incorrect fn Name
    this.addingMoreMedicalHistory();
    this.displayAppoint(this.val);
  }


  deleteFieldValue(index) {
    this.checkout.splice(index, 1);
  }
  exit() {
    this.forms['medicalHistory'].reset();
    window.location.reload();
  }
  displayAppoint(values) {
    this.isError = false;
    try {
      if (values.chkdob) {
        let inputDate = new NgbDate(
          values.chkdob.year,
          values.chkdob.month,
          values.chkdob.day
        );
        let valDate = (this.calendar.isValid(inputDate))
          ? values.chkdob = `${values.chkdob.year}-${values.chkdob.month}-${values.chkdob.day}` : this.isError = true;

      }
      if (!this.isError) {
        this.isCheckOutLoading = true;
        let input = {
          org_code: this.org_code,
          apdate: values.chkdob,
          pat_name: values.model,
          doc_name: values.model2,
        };
        let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));
        if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
          input["drid"] = parseInt(this.dr_id);
        }

        console.log("Search  1", input);
        this.trimFormValuesService.trimValues(input);
        this.vproService.postCheckin(input).subscribe(
          (data: any) => {
            this.checkout = data;
            console.log("this.checkout,", this.checkout)
            if (input.doc_name) {
              this.checkout = this.checkout.filter(docname =>

                docname.physician_first_name.toLowerCase().includes(input.doc_name.toLowerCase())
                || docname.physician_last_name.toLowerCase().includes(input.doc_name.toLowerCase())
                || docname.physician_first_name.toString().concat(" ", docname.physician_last_name.toString()).toLowerCase().includes(input.doc_name.toLowerCase()))
            }
            this.checkout = this.checkout.filter(list => list.dob != null)
            // this.checkout = sortBy(this.checkout, 'aptime'); // Data Sorter via underscore.js
            // this.checkout = sortBy(this.checkout, 'apdate'); // Data Sorter via underscore.jz
            let norecmsg = (this.checkout && this.checkout.length == 0)
              ? this.innerHtml = "<h3 align='center'>No Active Checkins</h3>" : this.innerHtml = "";
            this.isCheckOutLoading = false;
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (excep) {
      console.log(excep);
    }
  }
  delete(invoice) {
    let invoice_id = invoice.id
    // this.spinner.show();
    this.vproService.deleteInvoice(invoice_id).subscribe(
      (data) => {
        // this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 2500,
        });

        Toast.fire({
          type: "success",
          title: "Invoice has been deleted successfuly",
        });
        this.fetchservicereport(this.aptid, this.patid);
      })
  }
  /** updating patient checkout  */
  public patientCheckout(cid: number, pid: number): void {
    Swal.fire({
      title: 'Complete appointment',
      text: " Are you sure ?",
      type: 'info',
      showCancelButton: true,
      buttonsStyling: true,
      confirmButtonClass: 'btn btn-danger',
      confirmButtonText: 'Yes',
      cancelButtonClass: 'btn btn-secondary'
    }).then((result) => {
      if (result.value) {

        this.vproService
          .updateCheckin(pid, { cid: cid, chkstatus: "Completed", drid: parseInt(localStorage.getItem("uid")) })
          .subscribe(
            (result) => {
              this.checkout = this.checkout.filter((record) => record.aid != cid);
            },
            (err) => {
              console.log(err);
            }
          );


        // Show confirmation
        Swal.fire({
          title: 'Check-Out confirm',
          text: 'Patient has been Checked-Out successfully',
          type: 'success',
          showConfirmButton: false,
          timer: 2000,

        });
        this.router.navigate(['/appointments/Checkin']);
      }
    })

  } catch(excep) {
    console.log(excep)
  }


  public formatTime(value) {
    let res;
    if (value && typeof value === "string") {
      let keys = value.split(":");
      res = this.getTime(keys[0]) + " : " + keys[1] + " " + this.getFormat(keys[0]);
    }
    return res;
  }
  getTime(time) {
    if (parseInt(time) > 12) {
      time = (parseInt(time) - 12).toString();
    }
    return time;
  }

  getFormat(value) {
    if (parseInt(value) < 12) {
      return 'AM';
    } else {
      return 'PM';
    }
  }
  getback() {
    this.location.back();
  }

  editRequest(aid, pid): void {
    this.ppids = pid;
    this.aaid = aid;

    this.modal.open(this.editRequestModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  showprescr(aid, pid, drid): void {

    this.fetchPreviousPrescriptions(aid, pid, drid);
    this.aaid = aid;
    this.modal.open(this.showprescriptionModal, { size: 'lg', centered: true, backdrop: 'static' });
  }
  showlabrep($event, aid, pid): void {
    this.fetchlabreport(aid, pid);
    this.aaid = aid;
    this.modal.open(this.showlabrepModal, { size: 'lg', centered: true, backdrop: 'static' });

  }

  showservicerep($event, aid, pid, drid): void {
    this.ppids = pid;
    this.aaid = aid;
    this.dr_id = drid;
    this.fetchservicereport(aid, pid);
    console.log("showserviceRep   showserviceRep")
    this.modal.open(this.showservicerepModal, { size: 'lg', centered: true, backdrop: 'static' });

  }
  // BILL GENERATION MODULES

  addMedHistRecord(): FormGroup {
    return this.fb.group({
      sid: [null],
      scost: [null],
    });
  }



  getOrgDet(usereid: string) {
    try {
      this.addPService.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.orgdet = res;
          for (let i of this.orgdet) {
            this.extend.org_code = i.org_code;
            console.log(this.extend.org_code);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  /** adding more medical history */
  public addingMoreMedicalHistory(): void {
    this.patient_med_history = this.forms.medicalHistory.get(
      "patient_med_history"
    ) as FormArray;
    this.patient_med_history.push(this.addMedHistRecord());
    this.service_cost.push([]);
  }

  /** removing medical history */
  public removingMedicalHistory(i: number): void {
    this.patient_med_history.removeAt(i);
    // this.calculate();
  }


  get f() {
    return this.forms[this.currentTab].controls;
  }



  savePatient() {
    let data = {
      ...this.forms.medicalHistory.value,
    };
    console.log("====================drid", this.dr_id)
    // save 
    if (data.patient_med_history && data.patient_med_history.length > 0) {
      data.patient_med_history.forEach((x, index) => {

        if (data.patient_med_history[index].scost == null || data.patient_med_history[index].sid == null) {


          this.diseaseList.forEach((type) => {
            if (type.service_id == data.patient_med_history[index].sid) {
              data.patient_med_history[index].scost = type.service_cost;
            }
          });



          console.log("data.patient_med_history[index]", data.patient_med_history[index])
          data.patient_med_history[index].aid = this.aptid;
          data.patient_med_history[index].pid = this.patid;
          data.patient_med_history[index].drid = parseInt(this.dr_id);
          var today = new Date();
          var date = today.getDate();
          var month = today.getMonth() + 1;
          var year = today.getFullYear();
          var current_date = year + '-' + month + '-' + date;
          data.patient_med_history[index].c_date = current_date;
          // const Toast = Swal.mixin({
          //   toast: true,
          //   position: "top",
          //   showConfirmButton: false,
          //   timer: 3500,
          // });
          // Toast.fire({
          //   type: "error",
          //   title: "Some value is missing.",
          // });
          // data = null;
          // return null;
        }
        else {
          data.patient_med_history[index] = Utils.removeNullAndEmpty(
            data.patient_med_history[index]
          );
          data.patient_med_history[index].aid = this.aptid;
          data.patient_med_history[index].pid = this.patid;
          data.patient_med_history[index].drid = parseInt(this.dr_id);
          var today = new Date();
          var date = today.getDate();
          var month = today.getMonth() + 1;
          var year = today.getFullYear();
          var current_date = year + '-' + month + '-' + date;
          data.patient_med_history[index].c_date = current_date;
        }

      });
      data.patient_med_history = data.patient_med_history.filter(

        (x) => x.sid || x.med_hist_year || x.scost
      );
    }


    this.spinner.show();
    this.addPService.addServicecharge(data).subscribe(
      (res) => {
        //this.serviceLists = res;
        this.spinner.hide();
        // SweetAlert
        this.disableSubmit = true;
        this.fetchservicereport(this.aaid, this.ppids);
        this.forms.medicalHistory.removeControl("patient_med_history");
        this.forms.medicalHistory.addControl("patient_med_history", this.fb.array([]));
        this.addingMoreMedicalHistory();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });

        Toast.fire({
          type: "success",
          title: "Bill Genarated",
        });
        // window.location.reload();
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );

  }


  onChange(deviceValue, index) {
    console.log(deviceValue);
    console.log(index);

    this.diseaseList.forEach((type) => {
      if (type.service_id == deviceValue) {
        this.service_cost[index] = type.service_cost;
      }
    });

  }

  //getLabTests fn name given Wrong
  getDiseaseList() {

    this.addPService.getOrgDet(this.dcred).subscribe(
      (res) => {
        this.orgdet = res;
        for (let i of this.orgdet) {
          this.extend.org_code = i.org_code;
          var orgcode = i.org_code;

          this.addPService.getLablists(orgcode).subscribe((res) => {
            this.diseaseList = res;
            console.log("this.diseaseList ", this.diseaseList)
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );


  }


  onSearchChange(searchValue: string) {
    var y: number = +searchValue;
    this.z = this.z + y;
    let ress = this.z.toString();
    // this.calculate();
  }



  printPage(eve) {
    let data = {
      aid: parseInt(this.aaid),
    }
    console.log("Appointment ID", data)
    if (eve.target.id === this.PrescriptionType.CURRENTPRESCRIPTION) {
      data['prescription'] = this.currentPrescriptionList;
      this.patService.CurrentPrescriptionPdf(data, `?type=offine_prescription`).subscribe((result) => {
        if (result) {

          this.pdf_url = environment.content_base_url + "/" + result;
          window.open(this.pdf_url);
        }
      });
    }
    this.pdf_url = "";
  }

  printPagee(eve) {
    let data = {
      aid: parseInt(this.aaid),

    }
    data['labrecord'] = this.testsList;
    this.patService.CurrentPrescriptionPdf(data, `?type=offine_lab`).subscribe((result) => {
      if (result) {
        this.pdf_url = environment.content_base_url + "/" + result;
        window.open(this.pdf_url);
        console.log("LABREPORT:", this.pdf_url);
      }
    });
    this.pdf_url = "";
  }
  printConsult(consult_aid) {
    let data = {
      aid: parseInt(consult_aid),

    }
    data['consult_screen'] = {};
    console.log("data", data)
    console.log("url  1", environment.content_base_url + "/")
    this.patService.CurrentPrescriptionPdf(data, `?type=consult_screen`).subscribe((result) => {
      if (result) {
        console.log("url  2", environment.content_base_url + "/" + result)
        this.pdf_url = environment.content_base_url + "/" + result;
        window.open(this.pdf_url);
      }
    });
    this.pdf_url = "";
  }

  printInvoice(eve) {
    // console.log("this.aaid", this.aptid)
    let data = {
      aid: parseInt(this.aaid),
      // aid: parseInt(this.testsList[0].aid)
    }
    // console.log("111111111111111111111111111111111111111111111111111", this.testsList)
    data['invoicerecord'] = this.serviceList;
    this.patService.CurrentPrescriptionPdf(data, `?type=offine_Invoice`).subscribe((result) => {
      if (result) {
        this.pdf_url = environment.content_base_url + "/" + result;
        window.open(this.pdf_url);
      }
    });
    this.pdf_url = "";
  }


  async fetchlabreport(aaid, pids) {
    // console.log("aaid", aaid)
    this.drid = localStorage.getItem("uid");
    this.pid = pids;
    this.currentPrescriptionList = [];
    this.spinner.show();
    // This working code for fetch labtest --Starts
    this.patService
      .fetchAppointTestsByPhysician({ pid: this.pid, aid: aaid })
      .subscribe((result) => {
        this.spinner.hide();
        this.testsList = result;
      });
    // This working code for fetch labtest --Ends
  }

  async fetchservicereport(aaid, pids) {
    // console.log("aaid", aaid)
    this.aptid = aaid;
    this.patid = pids;
    let total: number = 0;
    this.currentSerList = [];
    this.spinner.show();
    // This working code for fetch labtest --Starts
    this.patService
      .getAppLablists(aaid)
      .subscribe((result) => {
        this.spinner.hide();
        // this.testserviceList = result;

        if (result && result.length > 0) {
          result.forEach((record) => {

            //this.currentSerList.push((record['scost']).toFixed(2));

          });
        }

        this.serviceList = result;
        console.log("this.serviceList", this.serviceList)
        console.log("this.serviceList.length", this.serviceList.length)
        for (var i = 0; i < this.serviceList.length; i++) {
          // console.log("this.serviceList[i].amount", i);
          // console.log("this.serviceList[i].amount", this.serviceList[i].scost);
          total += parseFloat(this.serviceList[i].scost);
          this.totalamount = total.toFixed(2);
          // console.log("TOTAL::", total);

        }

        for (var i = 0; i < this.serviceList.length; i++) {

          let sco = parseFloat(this.serviceList[i].scost);
          this.serviceList[i].scost = (sco.toFixed(2));

        }
      });
    // This working code for fetch labtest --Ends
  }



  async fetchPreviousPrescriptions(aaid, pids, uid) {

    this.drid = uid;
    console.log("uid", uid)
    this.pid = pids;
    this.currentPrescriptionList = [];
    this.spinner.show();
    this.patService
      .fetchPatientPrescriptionsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        console.log("result", result)
        this.spinner.hide();
        if (result && result.length > 0) {
          result.forEach((record) => {
            if (moment(record.edate).format("YYYY-MM-DD") >= this.momentDate) {
              this.currentPrescriptionList.push(record);
            }
          });
        }
      });
  }


}
